import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { brandLogos, logoSrc } from '../data/logos';
export function LogoStrip() {
  const reduce = useReducedMotion();
  const items = [...brandLogos, ...brandLogos];
  return <section aria-label="Teams shipping with LocalTask" className="border-y border-line" data-id="element-206" data-mp="dolbza4131ob">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6 py-8 md:flex-row md:gap-10" data-id="element-207" data-mp="hovg0h89fi0j">
        <p className="shrink-0 font-mono text-xs text-muted" data-id="element-208" data-mp="3xqok2f1pw1a">// shipping with</p>
        <div className="w-full overflow-hidden" data-id="element-209" data-mp="8qjuuuq5xcfh">
          <motion.ul className="flex w-max items-center" animate={reduce ? undefined : {
          x: ['0%', '-50%']
        }} transition={{
          duration: 24,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-210" data-mp="3q69u6uk7csjo">
            {items.map((logo, i) => <li key={`${logo.name}-${i}`} aria-hidden={i >= brandLogos.length} className="shrink-0 pr-16" data-id="element-211" data-mp="3h63fx6gojojg" data-mpi={i}>
                <img src={logoSrc(logo.domain)} alt={logo.name} title={logo.name} width={40} height={40} className="h-10 w-10 rounded-lg object-contain" loading="lazy" data-id="element-212" data-mp="3m3vdag03g2v1" />
              </li>)}
          </motion.ul>
        </div>
      </div>
    </section>;
}